import {
  NEXT_STEP,
  LAST_STEP,
  SKIP_STEP,
  SKIP_BACK,
  SET_VALID,
  SET_INVALID,
  SET_BACK_VALID,
  SET_BACK_INVALID,
  NO_STICKY,
  //new\\
  SKIPPED_BACKWARDS,
  PARTICIPANTS_RESET,
} from "../constants";
import { currentLocale } from "../locale";

const initialStepper = {
  currentStep: 0,
  noSticky: false,
  flashing: false,
  //new\\
  skippedBackwards: false,
  steps: [
    {
      step: 0,
      isValid: true, //1,
      optional: false,
      // current: true,
      title: currentLocale.step0Title
    },
    {
      step: 1,
      //  optInMarketing: false,
      isValid: false, //1,
      optional: true,
      //   current: false,
      title: currentLocale.step1Title
    },
    {
      step: 2,
      isValid: false,
      // current: false,
      optional: false,
      title: currentLocale.step2Title
    },
    {
      step: 3,
      isValid: false, //0,
      // current: false,
      optional: false,
      title: currentLocale.step3Title
    },

    {
      step: 4, //ex instructionalVideo
      optional: true, //shows if true
      isValid: false, //0,
      // current: false,
      title: currentLocale.step4Title
    },
    {
      step: 5,
      isValid: 1,
      optional: false,
      //  current: false,
      title: currentLocale.step5Title
    },
    {
      step: 6,
      isValid: 0,
      optional: false,
      // current: false,
      title: currentLocale.step6Title
    },
    {
      step: 7,
      isValid: 1,
      optional: false,
      // current: false,
      title: currentLocale.step7Title
    },
    {
      step: 8,
      isValid: 0,
      optional: false,
      // current: false,
      title: currentLocale.step8Title
    },
    {
      step: 9,
      title: currentLocale.step9Title
    }
  ]
};

export const stepper = (state = initialStepper, action) => {
  switch (action.type) {
    case NEXT_STEP:
      return {
        ...state,
        currentStep: state.currentStep + 1,
        steppedBack: false
      };
    case SKIP_STEP:
      return {
        ...state,
        currentStep: state.currentStep + 2,
        steppedBack: false
      };
    case LAST_STEP:
      return {
        ...state,
        currentStep: state.currentStep - 1,
        steppedBack: true
      };
    case SKIP_BACK:
      return {
        ...state,
        currentStep: state.currentStep - 2,
        steppedBack: true
      };
    case SKIPPED_BACKWARDS:
      return { ...state, skippedBackwards: true };

    case PARTICIPANTS_RESET:
      return { ...state, skippedBackwards: false };
    case NO_STICKY:
      return { ...state, noSticky: true };
    // return Object.assign({}, state, action.payload.noSticky)
    default:
      return state;
  }
};

export const validBackStep = (state = {}, action) => {
  switch (action.type) {
    case SET_BACK_VALID:
      return action.payload;
    case SET_BACK_INVALID:
      return action.payload;
    default:
      return state;
  }
};

export const validStep = (state = {}, action) => {
  switch (action.type) {
    case SET_VALID:
      return action.payload;
    case SET_INVALID:
      return action.payload;

    default:
      return state;
  }
};

